module.exports = __webpack_public_path__ + "static/media/covidMob.a99cc685.webp";